export default "__VITE_ASSET__BEWciTsD__"